<template>
  <w-autocomplete-lazy
    class='w-multiple-selection-filter'
    v-bind='filterProps($props, ["items"])'
    :items='sortedItems'
    v-on='$listeners'
  >
    <template
      v-if='filterHasFilterOptions'
      #append-inner
    >
      <MultipleSelectionFilterMenu
        :filter-options='filterOptions'
        :filter-option-text='filterOptionText'
        :option-select-disabled='optionSelectDisabled'
        @click:filterOption='handleFilterOption'
      />
    </template>
  </w-autocomplete-lazy>
</template>

<script>
import WorkAutocompleteLazy from '@/components/base_components/WorkAutocompleteLazy';
import multipleSelectionMixin from "@/components/global_components/filters/multiple_selection_filter/shared/multiple-selection-mixin";
import { filterProps } from '@/utils/functional-component-utils';
import sortedItems from '@/mixins/component/sorted-items-mixin';

export default {
  name: 'WorkMultipleSelectionFilterLazy',
  components: { MultipleSelectionFilterMenu: () =>
    import('@/components/global_components/filters/multiple_selection_filter/shared/MultipleSelectionFilterMenu')
  },
  mixins: [multipleSelectionMixin(WorkAutocompleteLazy.props), sortedItems],
  methods: {
    filterProps: filterProps,
  },
};
</script>

